import { AgentRunEventType } from '../agent-runs/index.js';
export const TOOL_PRESENTATION_STATUSES = ['running', 'completed', 'failed', 'blocked', 'unblocked'];
export const KNOWN_TOOL_PRESENTATION_STATUSES = TOOL_PRESENTATION_STATUSES;
export const ToolPresentationStatus = {
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    Blocked: 'blocked',
    Unblocked: 'unblocked',
};
export const TOOL_PRESENTATION_ICON_CATEGORIES = [
    'github',
    'git',
    'memory',
    'delegation',
    'decision',
    'work_item',
    'search',
    'terminal',
    'file',
    'web',
    'connector',
    'tool',
    'repository',
];
export const KNOWN_TOOL_PRESENTATION_ICON_CATEGORIES = TOOL_PRESENTATION_ICON_CATEGORIES;
export const ToolPresentationIconCategory = {
    Github: 'github',
    Git: 'git',
    Memory: 'memory',
    Delegation: 'delegation',
    Decision: 'decision',
    WorkItem: 'work_item',
    Search: 'search',
    Terminal: 'terminal',
    File: 'file',
    Web: 'web',
    Connector: 'connector',
    Tool: 'tool',
    Repository: 'repository',
};
export const DEFAULT_TOOL_PRESENTATION_ICON_CATEGORY = ToolPresentationIconCategory.Tool;
export const TOOL_PRESENTATION_VISIBILITIES = ['hidden', 'inline', 'modal'];
export const KNOWN_TOOL_PRESENTATION_VISIBILITIES = TOOL_PRESENTATION_VISIBILITIES;
export const ToolPresentationVisibility = {
    Hidden: 'hidden',
    Inline: 'inline',
    Modal: 'modal',
};
export const CAPABILITY_PRESENTATION_TEMPLATE_KEYS = [
    'running',
    'completed',
    'failed',
    'blocked',
    'unblocked',
    'summary',
];
export const KNOWN_CAPABILITY_PRESENTATION_TEMPLATE_KEYS = CAPABILITY_PRESENTATION_TEMPLATE_KEYS;
export const CapabilityPresentationTemplateKey = {
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    Blocked: 'blocked',
    Unblocked: 'unblocked',
    Summary: 'summary',
};
export const TOOL_PRESENTATION_HIDDEN_METADATA_KINDS = ['internal_run_input', 'system_context_block'];
/**
 * Tool-call lifecycle event types that carry a presentation snapshot. Identities
 * are owned by the public agent-runs vocabulary; this is the presentation-relevant
 * subset, closed so the status map below stays a total table.
 */
export const TOOL_CALL_LIFECYCLE_EVENT_TYPES = [
    AgentRunEventType.ToolCallStarted,
    AgentRunEventType.ToolCallCompleted,
    AgentRunEventType.ToolCallFailed,
    AgentRunEventType.ToolCallBlocked,
    AgentRunEventType.ToolCallUnblocked,
];
export const ToolCallLifecycleEventType = {
    Started: AgentRunEventType.ToolCallStarted,
    Completed: AgentRunEventType.ToolCallCompleted,
    Failed: AgentRunEventType.ToolCallFailed,
    Blocked: AgentRunEventType.ToolCallBlocked,
    Unblocked: AgentRunEventType.ToolCallUnblocked,
};
export const TOOL_CALL_EVENT_TYPE_TO_PRESENTATION_STATUS = {
    [AgentRunEventType.ToolCallStarted]: ToolPresentationStatus.Running,
    [AgentRunEventType.ToolCallCompleted]: ToolPresentationStatus.Completed,
    [AgentRunEventType.ToolCallFailed]: ToolPresentationStatus.Failed,
    [AgentRunEventType.ToolCallBlocked]: ToolPresentationStatus.Blocked,
    [AgentRunEventType.ToolCallUnblocked]: ToolPresentationStatus.Unblocked,
};
//# sourceMappingURL=vocabulary.js.map